import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-md-6 mb-20" }
const _hoisted_9 = { class: "col-md-6 mb-20" }
const _hoisted_10 = { class: "col-md-12 mb-20" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_12 = {
  key: 1,
  class: "d-flex mt-2 align-items-start flex-wrap"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "col-md-6 mb-20" }
const _hoisted_15 = { class: "col-md-6 mb-20" }
const _hoisted_16 = { class: "col-md-6 mb-20" }
const _hoisted_17 = { class: "col-md-6 mb-20" }
const _hoisted_18 = { class: "col-md-12 mb-20" }
const _hoisted_19 = { class: "col-md-12 mb-20" }
const _hoisted_20 = { class: "col-md-12 mb-20" }
const _hoisted_21 = { class: "col-md-6 mb-20" }
const _hoisted_22 = { class: "col-md-6 mb-20" }
const _hoisted_23 = { class: "col-md-6 mb-20" }
const _hoisted_24 = { class: "col-md-6 mb-20" }
const _hoisted_25 = { class: "col-md-4 mb-20" }
const _hoisted_26 = { class: "col-md-4 mb-20" }
const _hoisted_27 = { class: "col-md-4 mb-20" }
const _hoisted_28 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_29 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.imagepreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imagepreview,
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/NoImage.png'),
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_7)),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
              type: "text",
              class: "form-control shadow-none rounded-0",
              placeholder: "Nom complet",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.cin) = $event)),
              type: "text",
              class: "form-control shadow-none rounded-0",
              placeholder: "CIN",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.cin]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN (Pièces jointes) *", -1)),
            _createElementVNode("input", {
              type: "file",
              class: "form-control shadow-none rounded-0",
              accept: "image/*",
              multiple: "",
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileSelected && _ctx.fileSelected(...args)))
            }, null, 32),
            (_ctx.attachments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (a, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "small text-muted"
                    }, _toDisplayString(a.name) + " (" + _toDisplayString((a.size / 1024 / 1024).toFixed(1)) + " MB) ", 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.urls.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (url, i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: i,
                      src: url,
                      class: "me-2 mb-2",
                      style: {"height":"120px","object-fit":"cover"}
                    }, null, 8, _hoisted_13))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-danger",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeFiles && _ctx.removeFiles(...args)))
                  }, " Supprimer ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.phone) = $event)),
              type: "text",
              pattern: "^0[0-9]{9}$",
              class: "form-control shadow-none rounded-0",
              placeholder: "0XXXXXXXXX",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse électronique *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.email) = $event)),
              type: "email",
              class: "form-control shadow-none rounded-0",
              placeholder: "exemple@email.com",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.password) = $event)),
              type: "password",
              class: "form-control shadow-none rounded-0",
              placeholder: "Mot de passe",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation de mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.c_password) = $event)),
              type: "password",
              class: "form-control shadow-none rounded-0",
              placeholder: "Confirmer mot de passe",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.c_password]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville utilisateur *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.city_user) = $event)),
              type: "text",
              class: "form-control shadow-none rounded-0",
              placeholder: "Ville utilisateur",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.city_user]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville *", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "statut",
              modelValue: _ctx.form.city,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.city) = $event)),
              label: "name",
              placeholder: "Choisir une ville",
              options: _ctx.citiesList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse *", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.adresse) = $event)),
              rows: "2",
              class: "form-control shadow-none rounded-0",
              placeholder: "Adresse complète",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.adresse]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du banque *", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "banque",
              modelValue: _ctx.form.bank,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.bank) = $event)),
              label: "name",
              placeholder: "Choisir une banque",
              options: _ctx.bankList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro du compte *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.rib) = $event)),
              type: "number",
              class: "form-control shadow-none rounded-0",
              minlength: "24",
              maxlength: "24",
              placeholder: "RIB",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.rib]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Agence *", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "agence",
              modelValue: _ctx.form.agency,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.agency) = $event)),
              label: "name",
              placeholder: "Choisir une agence",
              options: _ctx.agencyList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fonction *", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "fonction",
              modelValue: _ctx.form.fonction,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.fonction) = $event)),
              label: "name",
              placeholder: "Choisir une fonction",
              options: _ctx.functionsList
            }, null, 8, ["modelValue", "options"])
          ]),
          (_ctx.form.fonction?.name === 'Livreur')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Zone *", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    id: "zone",
                    modelValue: _ctx.form.zone,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.zone) = $event)),
                    label: "name",
                    placeholder: "Choisir une zone",
                    options: _ctx.zoneList
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de livraison *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.livred_fees) = $event)),
                    type: "text",
                    class: "form-control shadow-none rounded-0",
                    placeholder: "Frais de livraison"
                  }, null, 512), [
                    [_vModelText, _ctx.form.livred_fees]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de refus *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.refused_fees) = $event)),
                    type: "text",
                    class: "form-control shadow-none rounded-0",
                    placeholder: "Frais de refus"
                  }, null, 512), [
                    [_vModelText, _ctx.form.refused_fees]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", _hoisted_29, [
              _cache[40] || (_cache[40] = _createTextVNode(" Enregistrer ", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                : _createCommentVNode("", true)
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-link text-danger"
            }, " Annuler ", -1))
          ])
        ])
      ], 32)
    ])
  ]))
}